import React, {Component} from 'react';
import Column from "@amzn/meridian/column";
import Loader from "@amzn/meridian/loader";

export default class Loading extends Component{
    render() {
        return (
            <Column height={this.props.height} alignmentHorizontal="center">
                <Loader/>
            </Column>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/Loading.js